import { approverType, requestStatus } from "../../../../../constants";
import { requestStatusTypes } from "../../types";

export interface GetLabelStatusArgs {
  status: string;
  step?: number;
  requestCompletedLabel: string;
}

export const getLabelStatus = ({
  status,
  step,
  requestCompletedLabel = "",
}: GetLabelStatusArgs) => {
  if (
    (status === requestStatus.submitted && step === approverType.assignee) ||
    status === requestStatusTypes.submittedAssignee
  )
    return "Đang đợi thực thi";
  if (status === requestStatus.submitted) return "Đang đợi duyệt";
  if (status === requestStatusTypes.acceptance) return "Đã tiếp nhận"
  if (status === requestStatus.approved) return "Đã duyệt";
  if ([requestStatus.inProgress, "InProgress"].includes(status))
    return "Đang thực thi";
  if (status === requestStatus.rejected) return "Đã từ chối";
  if (status === requestStatus.completed) return `Đã ${requestCompletedLabel}`;
};
